import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getSheetUtilityClass(slot) {
  return generateUtilityClass('JoySheet', slot);
}
const sheetClasses = generateUtilityClasses('JoySheet', ['root', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid']);
export default sheetClasses;